import { styled } from '@mui/system'
import { Stack, Typography } from '@mui/material'

export const Container = styled(Stack)`
  justify-content: center;
  align-items: center;
`

export const ContentWrapper = styled(Stack)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
`

export const StatusLabel = styled(Typography)`
  font-weight: bold;
`
